import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { product } from 'src/app/models/interfaces';
import { AlertsService } from 'src/app/services/alerts.service';
import { CarritoService } from 'src/app/services/carrito.service';
import { PreloadImgService } from 'src/app/services/preload-img.service';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss'],
})
export class ProductoComponent implements OnInit {

  @Input() producto? : product
  @Input() genero?: string = '';
  imgDefault = this.preloadImg.defaultImg
  constructor(public carrito: CarritoService,
    private fb: FormBuilder,
    private alersSv : AlertsService,
    public router : Router,
    private preloadImg : PreloadImgService, ) { }

    formCantidad = this.fb.group({
      talla: [null, Validators.required],
      cantidad: [1, Validators.required]
    })


    private readonly singulares: Record<string, string> = {
  'mujeres': 'mujer',
  'hombres': 'hombre',
  'ninos':   'nino',
  'ninas':   'nina',
};


get imagenDelGenero(): string {
  if (!this.producto?.image?.length) return this.imgDefault;

  const genero = this.genero?.toLowerCase().trim();
  if (!genero) return this.producto.image[0]?.url || this.imgDefault;

  const singular = this.singulares[genero] ?? genero;

  const tieneGenero = (img: any, value: string) => {
    if (Array.isArray(img.gender)) {
      return img.gender.some((g: string) => g?.toLowerCase().trim() === value);
    }
    return (img.gender ?? '').toString().toLowerCase().trim() === value;
  };

  // 1. Buscar coincidencia exacta (plural o singular) dentro del array de gender
  const matchGenero = this.producto.image.find((img: any) =>
    img?.url && (tieneGenero(img, genero) || tieneGenero(img, singular))
  );

  if (matchGenero) return matchGenero.url;

  // 2. Fallback: imagen sin gender definido (array vacío o ausente)
  const matchSinGenero = this.producto.image.find((img: any) =>
    img?.url && (!img.gender || (Array.isArray(img.gender) && img.gender.length === 0))
  );

  return matchSinGenero?.url || this.producto.image[0]?.url || this.imgDefault;
}
  addProd =[]

  ngOnInit() {
    this.formCantidad.valueChanges.subscribe(

      res =>{
        this.addProd = []
        this.addProd.push(res)
        console.log(this.producto);
        console.log(this.addProd);
      },
    )
  }



  async addProduct(){

    if (this.carrito.auth.uid) {
      if (this.producto?.colors) {
     this.router.navigate(['/detailproduct', this.genero, this.producto.id])
        return
      }
      if (this.addProd.length < 1 && !this.producto?.colors) {
        this.alersSv.presentAlert('por favor selecciona la talla del producto')
      } else {
        await this.carrito.addProduct(this.producto, this.addProd) ;
        console.log('datos agregados', this.producto, this.addProd);

        this.alersSv.presentToast('bottom', 'Producto agregado al carrito')
        this.formCantidad.reset()
      }
    }
    else{
      this.alersSv.presentAlert('Para hacer un pedido debes iniciar sesion')
      this.router.navigate(['/singin'])
    }
  }

}
